import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { StylesInstitutionsModel } from './styles-institutions.model';

export class StylesInstitutionsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'StylesInstitutionsConfiguration';
  nodataLocalizationKeyName = 'styleInstitutions';
  readonly reportSection = ReportSection.StylesInstitutions;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_StyleInstitutions];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'styleInstitutions';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Style';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface StylesInstitutionsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_StyleInstitutions]: StylesInstitutionsModel;
}
